import { defineMessages } from 'react-intl';

export default defineMessages({
    formerEntityErrorTitle: {
        id: 'quoteandbind.rv.views.rv-lifeAgent-details.LifeAgent.Additional Information Tab',
        defaultMessage: 'Additional Information Tab'
    },
    formerEntityErrorMessage: {
        id: 'quoteandbind.rv.views.rv-lifeAgent-details.LifeAgent.Additional Information Tab: Atleast one Former entity record is needed',
        defaultMessage: 'Additional Information Tab: Atleast one Former entity record is needed'
    },
});